import { Slide } from "react-toastify";

export const APP_CONSTANTS = {
  sanitizeHtmlConfig: {
    allowedTags: ["img", "p", "span", "div", "ul", "li"],
    allowedAttributes: {
      img: ["alt", "src", "style"],
      a: ["class", "href", "target", "rel"],
      p: ["*"],
      span: ["*"],
      div: ["*"],
    },
  },
  toasterConfig: {
    position: "top-center",
    autoClose: 5000,
    icon: true,
    transition: Slide,
    closeOnClick: true,
    toastClassName: "rounded-5",
  },
};

export const APP_MESSAGES = Object.freeze({
  defaultErrorMessage: "Something went wrong, please try again!",
});

export const Environments = Object.freeze({
  Dev: "dev",
  QA: "qa",
  Staging: "staging",
  Production: "production",
});

export const ListeningStatus = Object.freeze({
  Preparing: "PREPARING",
  Idle: "IDLE",
  StartingToListen: "STARTING_TO_LISTEN",
  Listening: "LISTENING",
  Processing: "PROCESSING",
  DoneProcessing: "DONE_PROCESSING",
});

export const MAX_CONTINUOUS_LISTENING_MINUTES = 2;
export const MAX_CONTINUOUS_IDLE_MINUTES = 5;

export const toastrTypes = ["error", "info", "warning"];

export const SliceOfConversationToPassToAPI = -5;

export const supportedLangauges = [
  {
    uid: "ar",
    langCode: "ar",
    langText: "Arabic - العربية",
    transcriptionDir: "rtl",
    dialects: [
      { dialectCode: "AE", dialectName: "United Arab Emirates", translatedDialectName: "اللهجة الإماراتية - الخليجية" },
      { dialectCode: "BH", dialectName: "Bahrain", translatedDialectName: "اللهجة البحرينية - الخليجية" },
      { dialectCode: "DZ", dialectName: "Algeria", translatedDialectName: "اللهجة الجزائرية" },
      { dialectCode: "EG", dialectName: "Egypt", translatedDialectName: "العامية المصرية" },
      { dialectCode: "IL", dialectName: "Israel", translatedDialectName: "اللهجة الإسرائيلية" },
      { dialectCode: "IQ", dialectName: "Iraq", translatedDialectName: "اللهجة العراقية" },
      { dialectCode: "JO", dialectName: "Jordan", translatedDialectName: "اللهجة الأردنية" },
      { dialectCode: "KW", dialectName: "Kuwait", translatedDialectName: "اللهجة الكويتية - الخليجية" },
      { dialectCode: "LB", dialectName: "Lebanon", translatedDialectName: "اللهجة اللبنانية - الشامية" },
      { dialectCode: "LY", dialectName: "Libya", translatedDialectName: "اللهجة الليبية" },
      { dialectCode: "MA", dialectName: "Morocco", translatedDialectName: "اللهجة المغربية - الدارجة" },
      { dialectCode: "OM", dialectName: "Oman", translatedDialectName: "اللهجة العُمانية - الخليجية" },
      { dialectCode: "PS", dialectName: "Palestine", translatedDialectName: "اللهجة الفلسطينية" },
      { dialectCode: "QA", dialectName: "Qatar", translatedDialectName: "اللهجة القطرية - الخليجية" },
      { dialectCode: "SA", dialectName: "Saudi Arabia", translatedDialectName: "اللهجة السعودية - الخليجية" },
      { dialectCode: "SY", dialectName: "Syria", translatedDialectName: "اللهجة السورية - الشامية" },
      { dialectCode: "TN", dialectName: "Tunisia", translatedDialectName: "اللهجة التونسية" },
      { dialectCode: "YE", dialectName: "Yemen", translatedDialectName: "اللهجة اليمنية" },
    ],
  },
  {
    uid: "bn",
    langCode: "bn",
    langText: "Bangla - বাংলা",
    dialects: [
      { dialectCode: "IN", dialectName: "India", dialectVoice: "bn-IN-BashkarNeural" },
    ],
  },
  {
    uid: "c-zh",
    langCode: "zh",
    langText: "Cantonese - 廣東話",
    dialects: [
      {
        dialectCode: "HK",
        dialectName: "Hong Kong (Traditional)",
        translatedDialectName: "香港",
        dialectVoice: "zh-HK-WanLungNeural",
        translationCode: "yue-HK",
      },
      {
        dialectCode: "CN",
        dialectName: "China (Simplified)",
        translatedDialectName: "广东省",
        localeCode: "yue-CN",
        dialectVoice: "yue-CN-YunSongNeural",
      },
    ],
  },
  {
    uid: "en",
    langCode: "en",
    langText: "English",
    hidden: true,
    default: true,
    dialects: [
      { dialectCode: "AU", dialectName: "Australia" },
      { dialectCode: "CA", dialectName: "Canada" },
      { dialectCode: "GB", dialectName: "United Kingdom" },
      // { dialectCode: "GH", dialectName: "Ghana" },
      // { dialectCode: "HK", dialectName: "Hong Kong SAR" },
      { dialectCode: "IE", dialectName: "Ireland" },
      { dialectCode: "IN", dialectName: "India" },
      // { dialectCode: "KE", dialectName: "Kenya" },
      // { dialectCode: "NG", dialectName: "Nigeria" },
      { dialectCode: "NZ", dialectName: "New Zealand" },
      // { dialectCode: "PH", dialectName: "Philippines" },
      // { dialectCode: "SG", dialectName: "Singapore" },
      // { dialectCode: "TZ", dialectName: "Tanzania" },
      { dialectCode: "US", dialectName: "United States", default: true },
      { dialectCode: "ZA", dialectName: "South Africa" },
    ],
  },
  {
    uid: "fr",
    langCode: "fr",
    langText: "French - Français",
    dialects: [
      { dialectCode: "FR", dialectName: "France" },
      // { dialectCode: "CA", dialectName: "Canada" },
      // { dialectCode: "CH", dialectName: "Switzerland" },
      // { dialectCode: "BE", dialectName: "Belgium" }
    ],
  },
  {
    uid: "ko",
    langCode: "ko",
    langText: "Korean - 한국어",
    dialects: [{ dialectCode: "KR", dialectName: "Korea" }],
  },
  {
    uid: "m-zh",
    langCode: "zh",
    langText: "Mandarin - 普通话",
    dialects: [
      {
        dialectCode: "CN",
        dialectName: "China (Mandarin, Simplified)",
        translatedDialectName: "中国",
      },
      {
        dialectCode: "TW",
        dialectName: "Taiwan (Mandarin, Traditional)",
        translatedDialectName: "台灣",
      },
      {
        dialectCode: "HK",
        dialectName: "Hong Kong (Mandarin, Traditional)",
        translatedDialectName: "香港",
      },
      {
        dialectCode: "cn-sichuan",
        dialectName: "China (Southwestern Mandarin)",
        translatedDialectName: "四川省",
      },
    ],
  },
  {
    uid: "ru",
    langCode: "ru",
    langText: "Russian - Русский",
    dialects: [{ dialectCode: "RU", dialectName: "Russia" }],
  },
  {
    uid: "es",
    langCode: "es",
    langText: "Spanish - Español",
    dialects: [
      { dialectCode: "US", dialectName: "United States", translatedDialectName: "Estadounidense" },
      { dialectCode: "AR", dialectName: "Argentina", translatedDialectName: "Argentino" },
      { dialectCode: "BO", dialectName: "Bolivia", translatedDialectName: "Boliviano" },
      { dialectCode: "CL", dialectName: "Chile", translatedDialectName: "Chileno" },
      { dialectCode: "CO", dialectName: "Colombia", translatedDialectName: "Colombiano" },
      { dialectCode: "CR", dialectName: "Costa Rica", translatedDialectName: "Costarricense" },
      { dialectCode: "CU", dialectName: "Cuba", translatedDialectName: "Cubano" },
      { dialectCode: "DO", dialectName: "Dominican Republic", translatedDialectName: "Dominicano" },
      { dialectCode: "EC", dialectName: "Ecuador", translatedDialectName: "Ecuatoriano" },
      { dialectCode: "ES", dialectName: "Spain", translatedDialectName: "Español" },
      { dialectCode: "GQ", dialectName: "Equatorial Guinea", translatedDialectName: "Ecuatoguineano" },
      { dialectCode: "GT", dialectName: "Guatemala", translatedDialectName: "Guatemalteco" },
      { dialectCode: "HN", dialectName: "Honduras", translatedDialectName: "Hondureño" },
      { dialectCode: "MX", dialectName: "Mexico", translatedDialectName: "Mexicano" },
      { dialectCode: "NI", dialectName: "Nicaragua", translatedDialectName: "Nicaragüense" },
      { dialectCode: "PA", dialectName: "Panama", translatedDialectName: "Panameño" },
      { dialectCode: "PE", dialectName: "Peru", translatedDialectName: "Peruano" },
      { dialectCode: "PR", dialectName: "Puerto Rico", translatedDialectName: "Puertorriqueño" },
      { dialectCode: "PY", dialectName: "Paraguay", translatedDialectName: "Paraguayo" },
      { dialectCode: "SV", dialectName: "El Salvador", translatedDialectName: "Salvadoreño" },
      { dialectCode: "UY", dialectName: "Uruguay", translatedDialectName: "Uruguayo" },
      { dialectCode: "VE", dialectName: "Venezuela", translatedDialectName: "Venezolano" },
    ],
  },
  {
    uid: "ur",
    langCode: "ur",
    langText: "Urdu - اردو",
    transcriptionDir: "rtl",
    dialects: [
      { dialectCode: "IN", dialectName: "India", dialectVoice: "ur-IN-SalmanNeural" },
      // Azure STT lists ur-IN; ur-PK isn't listed for STT in this table. [1](https://docs.azure.cn/en-us/ai-services/speech-service/language-support)
    ],
  },
  {
    uid: "sq",
    langCode: "sq",
    langText: "Albanian - Shqip",
    dialects: [{ dialectCode: "AL", dialectName: "Albania" }],
  },
  {
    uid: "uz",
    langCode: "uz",
    langText: "Uzbek - O'zbek",
    dialects: [{ dialectCode: "UZ", dialectName: "Uzbekistan" }],
  },
  {
    uid: "uk",
    langCode: "uk",
    langText: "Ukrainian - Українська",
    dialects: [
      {
        dialectCode: "UA",
        dialectName: "Ukraine",
        dialectVoice: "uk-UA-OstapNeural",
      },
    ],
  },
  ///// Do validate every field for Haitian Creole before enabling
  {
    uid: "ht",
    langCode: "ht",
    langText: "Haitian Creole - Kreyòl ayisyen",
    dialects: [{ dialectCode: "HT", dialectName: "Haiti" }],
  },
];

export const Report_Types = [
  { value: "SESSIONS", name: "Sessions per User per Language" },
  { value: "CONVERSATION", name: "Conversation Duration per School and Language" },
  { value: "FEEDBACK", name: "User Feedback Report" }
];
